export const STORES_APP_DEF_ID = '1380b703-ce81-ff05-f115-39571d94dfcd'
export const CATALOG_API_BASE_URL = '/_api/catalog-server/v1'
